import React from 'react';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';

import widgetSelector from 'Selectors/widgetsSelector';

import Thread from 'Components/threads/ThreadComponent';
import { pathToThread } from 'Utils/nav/NavHelpers';

class WidgetThreadListComponent extends React.Component {

	gotoThread = ( event ) => {
		if( event.currentTarget.dataset.threadid ) {
			this.props.dispatch( push( pathToThread( event.currentTarget.dataset.threadid ) ) );
		}
	};

	buildList( key, topic, users ) {
		let thisUser = this.props.showLast && topic.lastUserid && users[ topic.lastUserid ] ? users[ topic.lastUserid ] : users[ topic.forumUser ];

		return <li key={ key } data-threadid={ topic.id } onClick={ this.gotoThread }>
				<Thread
					thread={ topic }
					isSubscribable={ true }
					isSearch={ true }
					user={ thisUser }
					dispatch={ this.props.dispatch }
					ustate={ this.props.ustate }
					showLast={ this.props.showLast }
					selectedElements={ false }
				/>
			</li>;
	}

	threadListPage () {
		// We need to use results to preserve the order received
		const { entities: { topics, users }, result: { topics: resultTopics } } = this.props.widget;
		return resultTopics.map( ( k, i ) => this.buildList( i, topics[ k ], users ) );
	}

	render() {
		if( !this.props.widget || this.props.widget.isFetching ) {
			return <span />
		}

		return <ul>{ this.threadListPage() }</ul>;
	}
}

export default connect( widgetSelector )( WidgetThreadListComponent );


// WEBPACK FOOTER //
// ./src/components/widgets/WidgetThreadListComponent.js